export const savedTables = [
  {
    name: "CUSTOMERS",
    link: "https://api.github.com/repos/graphql-compose/graphql-compose-examples/contents/examples/northwind/data/csv/customers.csv",
  },
  {
    name: "EMPLOYEES",
    link: "https://api.github.com/repos/graphql-compose/graphql-compose-examples/contents/examples/northwind/data/csv/employees.csv",
  },
  {
    name: "PRODUCTS",
    link: "https://api.github.com/repos/graphql-compose/graphql-compose-examples/contents/examples/northwind/data/csv/products.csv",
  },
  {
    name: "ORDERS",
    link: "https://api.github.com/repos/graphql-compose/graphql-compose-examples/contents/examples/northwind/data/csv/orders.csv",
  },
  {
    name: "SUPPLIERS",
    link: "https://api.github.com/repos/graphql-compose/graphql-compose-examples/contents/examples/northwind/data/csv/suppliers.csv",
  },
];

export const savedQueries = [
  {
    name: "SELECT * FROM CUSTOMERS",
  },
  {
    name: "SELECT * FROM EMPLOYEES",
  },
  {
    name: "SELECT * FROM PRODUCTS",
  },
  {
    name: "SELECT * FROM ORDERS",
  },
  {
    name: "SELECT * FROM SUPPLIERS",
  },
];
